// extracted by mini-css-extract-plugin
export default {"map":"H0rL","click":"L_VC","container":"N4Il","widget":"Tcs0","panel":"XMFG"};